import React from 'react';

export function Logo() {
  return (
    <>
      <div className='w-6 h-6 bg-gray-900 rounded-full flex items-center justify-center'>
        <div className='w-3 h-3 bg-white rounded-full'></div>
      </div>
      <span className='text-xl font-bold'>ollie</span>
    </>
  );
}
